import { action } from 'satcheljs';
import { FolderForestTreeType } from 'owa-graph-schema';

export default action('onNewsSearchExit', (treeType: FolderForestTreeType) => ({ treeType }));
